import React from 'react'
import PropTypes from 'prop-types'
import { 
  Container, 
  StyledAvatar, 
  UserName,
  ContentWrapper,
  TextContainer
} from './styled'
import { Button, TextField, InputAdornment, Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'

const InternalHeader = ({ 
  title, 
  avatar, 
  subtitle, 
  background, 
  actionTitle, 
  actionMethod,
  showSearch,
  searchValue,
  onSearchChange,
  searchPlaceholder 
}) => {
  return (
    <Container background={background}>
      <ContentWrapper>
        <StyledAvatar alt="Avatar" src={avatar} />
        <TextContainer>
          <UserName>{title}</UserName>
          {subtitle && <div className="subtitle">{subtitle}</div>}
        </TextContainer>
      </ContentWrapper>
      
      {showSearch && (
        <Box sx={{ 
          width: { xs: '100%', md: '400px' },
          mt: { xs: 2, md: 0 }
        }}>
          <TextField
            fullWidth
            placeholder={searchPlaceholder || "Search..."}
            value={searchValue}
            onChange={onSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: 'rgba(255,255,255,0.7)' }} />
                </InputAdornment>
              ),
              sx: {
                backgroundColor: 'rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(10px)',
                borderRadius: '24px',
                color: 'white',
                '& .MuiOutlinedInput-notchedOutline': {
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  border: '1px solid rgba(255, 255, 255, 0.5)',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  border: '1px solid rgba(255, 255, 255, 0.7)',
                },
                '& input': {
                  color: 'white',
                  '&::placeholder': {
                    color: 'rgba(255,255,255,0.7)',
                    opacity: 1,
                  },
                },
              },
            }}
          />
        </Box>
      )}
      
      {actionTitle && (
        <Button
          variant="contained"
          startIcon={<AddIcon sx={{ color: 'primary.main' }} />}
          onClick={actionMethod}
          sx={{ 
            display: { xs: 'none', md: 'flex' },
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            color: 'primary.main', // Fixed color definition
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
            },
            fontWeight: '500',
            minWidth: 'auto',
            px: 3,
            py: 1,
            borderRadius: '20px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        >
          {actionTitle}
        </Button>
      )}
    </Container>
  )
}

InternalHeader.propTypes = {
  title: PropTypes.string,
  avatar: PropTypes.string,
  subtitle: PropTypes.string,
  background: PropTypes.string,
  actionTitle: PropTypes.string,
  actionMethod: PropTypes.func,
  showSearch: PropTypes.bool,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  searchPlaceholder: PropTypes.string,
}

export default InternalHeader